import { Form, Row, Col } from 'react-bootstrap'
import IconButton from 'components/ui/icon-button/IconButton'
import { faTrash } from '@fortawesome/pro-solid-svg-icons'

interface NoteProps {
  value: string
  onChange: (value: string) => void
  onRemove: () => void
}

const getValue = (value: string) => (+value < 0 ? '0' : value)

export const Note = ({ value, onChange, onRemove }: NoteProps) => (
  <Row>
    <Col xs className="pr-0">
      <Form.Control
        name="min"
        type="number"
        value={value}
        onChange={({ target }) => {
          const newValue = getValue(target.value)
          onChange(newValue)
        }}
      />
    </Col>
    <Col xs="auto" className="pl-0 d-flex align-items-center">
      <IconButton
        icon={faTrash}
        onClick={() => {
          onRemove()
        }}
      />
    </Col>
  </Row>
)

export default Note
